import React from 'react'
import RangeDatePickerAndActionsLayout from '../../../components/Layouts/range-date-picker-and-actions-layout'
import { ActionButtonEnum } from '../../../enums/actionButtonEnum'
import { getGamePerformanceReport } from '../../../services/reports'
import { DateFormatEnum } from '../../../enums/dateFormatEnum'
import {useAuth} from "../../../context/AuthProvider/useAuth";

function ReportGamePerformance() {
    const  affiliation  = useAuth().response?.affiliation

    return (
    <RangeDatePickerAndActionsLayout
      actions={[
        ActionButtonEnum.REFRESH, 
        ActionButtonEnum.SAVE_PDF, 
        ActionButtonEnum.SAVE_CSV
      ]}
      onRefresh={(startDateRage, endDateRange, output) =>
        getGamePerformanceReport({
          name: "Game Performance",
          beginDate: startDateRage.format(DateFormatEnum.MONTH_DAY_YEAR),
          endDate: endDateRange.format(DateFormatEnum.MONTH_DAY_YEAR),
          output,
        })
      }
      maxDays={affiliation==="manufacturer" || affiliation==="investigator"?365: 31}
    />
  )
}

export default ReportGamePerformance
